export default "__VITE_ASSET__0cdac48d__"